import React from 'react';
import Text from 'Components/Text';

export default function ContactInformation({ submittedBy }) {
  if (!submittedBy) return null;

  return (
    <section className='scene_section'>
      <header>Contact details</header>
      <Text
        mainWrapperClassName='text__wrapper_primary _margin_right_30'
        textClassName='text__text_primary'
        label='Name'
        value={`${submittedBy.firstName || ''} ${submittedBy.lastName || ''}`}
      />
      <Text
        mainWrapperClassName='text__wrapper_primary'
        textClassName='text__text_primary'
        label='Email'
        value={submittedBy.email || ''}
      />
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/Application/Details/ContactInformation.jsx